export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const ChangePasswordInitialValues: ChangePasswordInput = {
  currentPassword: '',
  newPassword: '',
};
